import { defineTool } from '@/shell/tool';

/** Network Groups (Flutter `/network-groups`). */
export default defineTool({
  id: 'network-groups',
  title: 'Network Groups',
  summary: 'The groups the networks are gathered into.',
  section: 'learning-backend',
  order: 30,
  icon: 'widgets',
  owner: '@Drabu',
  permission: 'network-groups:use',
  routes: () => import('./NetworkGroupsPage'),
});
